import React, { Component } from 'react'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { Redirect } from "react-router-dom"
import './registeruser.css'
import CSVReader from 'react-csv-reader'


let db = firebase.firestore();

class RegisterUser extends Component {
  constructor () {
    super ()
    this.state = {
      cedula: '',
      certification: '',
      courseName: '',
      date: '',
      userName: '',
      redirect: false
    }
    this.updateData = this.updateData.bind(this)
    this.RegisterUserOnDB = this.RegisterUserOnDB.bind(this)
    this.isLogged = this.isLogged.bind(this)
    this.SignOut = this.SignOut.bind(this)
  }

  componentWillMount () {
    this.isLogged()
  }

  updateData (e) {
    this.setState({ 
      [e.target.name]: e.target.value
    })
  }

  RegisterUserOnDB () {
    db.collection('users').add({
      Cedula: parseInt(this.state.cedula),
      Codigo: this.state.certification,
      Curso: this.state.courseName,
      Fecha: this.state.date,
      Nombre: this.state.userName
    })
    .then(() => alert('¡El usuario ha sido agregado!'))
    .catch((err) => alert('Hubo un error al intentar agregar el usuario. Código de error:', err))
  }
  
  isLogged () {
    let getSession = localStorage.getItem('logged')
    console.log(getSession)
    if(getSession == null) {
      this.setState({ redirect: true })
    } else {
      this.setState({ redirect: false })
    }
  }

  redirectToLogin = () => {
    if(this.state.redirect === true) {
      return <Redirect to="/login" />
    }
  }

  SignOut () {
    localStorage.removeItem('logged')
    this.setState({ redirect: true })
  }

  insertInfo = () => {
    console.log('tetsing')
    //console.log('data passed', obj)
  }

  handleForce (file) {
    file.forEach(async (docs, index) => {
      await db.collection('users').add({
        Cedula: parseInt(docs[0]),
        Codigo: docs[3],
        Curso: docs[4],
        Fecha: docs[2],
        Nombre: docs[1]
      })
      if(index === file.length -1) {
        alert('Los usuarios han sido agregados')
      }
    })
  }

  render () {
    return (
      <div className="container">
        {this.redirectToLogin()}  
        <div className="register-container">
          <h1>Registrar nuevo usuario</h1>
          <p className="buttons-container">
            <button className="btn btn-danger" onClick={this.SignOut}>Salir</button>
          </p>          
          <div>
            <p><input type="number" className="form-control" name="cedula" placeholder="Número de cédula" value={this.state.cedula} onChange={this.updateData} /></p>
            <p><input type="text" className="form-control" name="certification" placeholder="Código de la certificación" value={this.state.certification} onChange={this.updateData} /></p>
            <p><input type="text" className="form-control" name="courseName" placeholder="Nombre de la curso" value={this.state.courseName} onChange={this.updateData} /></p>
            <p><input type="date" className="form-control" name="date" placeholder="Fecha de realización" value={this.state.date} onChange={this.updateData} /></p>
            <p><input type="text" className="form-control" name="userName" placeholder="Nombre del usuario" value={this.state.userName} onChange={this.updateData} /></p>
            <p><input type="button" value="Agregar usuario" className="btn btn-success btn-block" onClick={this.RegisterUserOnDB}/></p>        
          </div>
          <fieldset>
            También puedes importar múltiples usuarios cargando un archivo .csv desde aquí: <br/><br/>
          <CSVReader label='Selecciona el archivo CSV aquí' onFileLoaded={this.handleForce} />
          </fieldset>
        </div>        
      </div>
    )
  }
}

export default RegisterUser